const steps = [
  {
    step: '01',
    title: '需求沟通',
    desc: '深入了解品牌诉求、目标受众和市场竞争格局，明确内容营销的核心目标',
    icon: 'ri-chat-1-line',
  },
  {
    step: '02',
    title: '策略制定',
    desc: '基于品牌洞察输出定制化内容营销方案，确定内容策略和传播路径',
    icon: 'ri-lightbulb-line',
  },
  {
    step: '03',
    title: '内容创作',
    desc: '专业团队落地执行，从文案、视觉到视频全链路高品质内容生产',
    icon: 'ri-pencil-ruler-line',
  },
  {
    step: '04',
    title: '发布运营',
    desc: '多平台精准分发，结合数据实时优化，确保内容触达目标用户',
    icon: 'ri-rocket-line',
  },
  {
    step: '05',
    title: '数据复盘',
    desc: '效果评估与策略迭代，通过数据洞察持续优化后续内容策略',
    icon: 'ri-bar-chart-line',
  },
];

export default function Process() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            合作流程
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            清晰透明的合作流程
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            从初次沟通到持续优化，我们建立了标准化的服务流程确保每个项目的高效交付
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-4">
          {steps.map((step, idx) => (
            <div key={step.step} className="relative group">
              <div className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 h-full transition-all duration-300 hover:border-primary-200">
                <div className="text-3xl font-heading font-bold text-primary-200 mb-3 group-hover:text-primary-400 transition-colors">
                  {step.step}
                </div>
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                  <i className={`${step.icon} text-lg text-primary-600`}></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {step.desc}
                </p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-s-line text-2xl text-background-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}